import './sass/main.scss';
import './scripts/footer';
import './scripts/modal_films';
import './scripts/loader';
import './scripts/library-films';
